<template>
	<div class="index-wrap">
		<div class="img-box">
			<img src="../../static/images/des3.jpg" />
			
			<div class="goBack" @click="goBack"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		methods: {
			goBack() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style lang="less" scoped>
	.index-wrap {
		width: 100%;
		.img-box {
			position: relative;
			width: 1200px;
			margin: 0 auto;
			.goBack {
				position: absolute;
				bottom: 1.3%;
				right: 15%;
				width: 120px;
				height: 30px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/Des3.vue